webpackJsonp([1],{

/***/ "+dOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"avatar"},[_c('a',{attrs:{"href":_vm.titleUrl,"target":"_blank"}},[_c('img',{attrs:{"src":"https://dolyw.gitee.io/reader/Image/headt.png"}})])]),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"item"},[_c('h1',{on:{"click":function($event){_vm.titleUrl = 'https://dolyw.com/go?url=https://me.dolyw.com'}}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/load?url=https://map.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-envira fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Map")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://blog.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-superpowers fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Blog")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://mark.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-snowflake-o fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Mark")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://dolyw.com"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-heartbeat fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Index")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://cv.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-futbol-o fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("MyCv")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://one.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-anchor fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("OnePiece")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://friend.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-weixin fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Friend")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://msg.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-hourglass-o  fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Message")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+g8z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1WAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_links_vue__ = __webpack_require__("dR/l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24252fdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_links_vue__ = __webpack_require__("5sNA");
function injectStyle (ssrContext) {
  __webpack_require__("wL+9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24252fdd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_links_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24252fdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "26dS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("iFcm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7beb122_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("+dOi");
function injectStyle (ssrContext) {
  __webpack_require__("7x++")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7beb122"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7beb122_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5sNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"content"},[_c('h1',{on:{"click":function($event){_vm.titleUrl = 'https://me.dolyw.com'}}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://res.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-envira fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Music")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://cmd.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("CMD")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://dolyw.com/404","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-link fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Links")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://lis.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-superpowers fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Video")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://text.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-font fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Random")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://char.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-picture-o fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Picture")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://mikutap.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-cogs fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Mikutap")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://lipstick.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-diamond fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Lipstick")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://article.dolyw.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-sun-o fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Article")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7lGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){_vm.openLink(item.link)}}},[_c('vue-danmaku',{ref:'danmaku-dolyw',refInFor:true,staticClass:"item-wrap",attrs:{"config":_vm.config,"danmus":item.danmus}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7x++":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B41e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BO8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CsB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 建立公共方法
/* harmony default export */ __webpack_exports__["a"] = ({
  // 属性复制
  copyProperty: function (p, c) {
    c = c || {}
    for (var i in p) {
      // 属性i是否为p对象的自有属性
      if (p.hasOwnProperty(i)) {
        // 属性i是否为复杂类型
        if (typeof p[i] === 'object') {
          // 如果p[i]是数组，则创建一个新数组
          // 如果p[i]是普通对象，则创建一个新对象
          // c[i] = Array.isArray(p[i]) ? [] : {}
          c[i] = Array.isArray(p[i]) ? [] : p[i] != null ? {} : null
          // 递归拷贝复杂类型的属性
          this.copyProperty(p[i], c[i])
        } else {
          // 属性是基础类型时，直接拷贝
          c[i] = p[i]
        }
      }
    }
    return c
  },
  // PC端返回false
  isMobile: function () {
    var viewType = navigator.userAgent.toLowerCase()
    console.log(viewType)
    return viewType.match(/(phone|pad|pod|midp|iphone|ipod|iphone os|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|rv:1.2.3.4|ucweb|fennec|wosbrowser|browserng|webos|symbian|windows ce|windows mobile|windows phone)/i)
  }
});


/***/ }),

/***/ "FBzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("fY6B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e297ead_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("7lGH");
function injectStyle (ssrContext) {
  __webpack_require__("BO8u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e297ead"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e297ead_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d26984_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PGxP");
function injectStyle (ssrContext) {
  __webpack_require__("B41e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23d26984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d26984_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_flexible__ = __webpack_require__("sVYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_index_scss__ = __webpack_require__("+g8z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util_js__ = __webpack_require__("CsB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);





// 引入公共JS


// axios

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.util = __WEBPACK_IMPORTED_MODULE_4__util_util_js__["a" /* default */];

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OyQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {};
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ "PGxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('ul',{staticClass:"navigation"},_vm._l((_vm.navigation),function(item,index){return _c('li',{key:index},[_c('a',{class:{'active': _vm.active === item},on:{"click":function($event){_vm.flip(item)}}},[_vm._v(_vm._s(item))])])})),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-panel flip",class:_vm.flipState ? 'out' : 'in'},[_c(_vm.inPage,{tag:"component",staticClass:"wrapper"})],1),_vm._v(" "),_c('div',{staticClass:"main-panel flip",class:_vm.flipState ? 'in' : 'out'},[_c(_vm.outPage,{tag:"component",staticClass:"wrapper"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PRMe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q72D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("项目")]),_vm._v(" "),_c('p',[_vm._v("惭愧，完成的项目一个都没有ˊ_>ˋ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QXir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chain_vue__ = __webpack_require__("Sy/i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c34ba9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chain_vue__ = __webpack_require__("gZn6");
function injectStyle (ssrContext) {
  __webpack_require__("hWjb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20c34ba9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c34ba9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sy/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {};
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ "WCuf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YJHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_project_vue__ = __webpack_require__("OyQr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99cb6176_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_project_vue__ = __webpack_require__("Q72D");
function injectStyle (ssrContext) {
  __webpack_require__("PRMe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99cb6176"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99cb6176_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cGTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"dblclick":function($event){_vm.openLink(item.link)}}},[_c('vue-danmaku',{ref:'danmaku-' + item.id,refInFor:true,staticClass:"item-wrap",attrs:{"config":item.config || _vm.config,"danmus":item.danmus},on:{"mouseIn":function($event){_vm.onMouseIn(item.id)},"mouseOut":function($event){_vm.onMouseOut(item.id)}}},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('div',{staticClass:"intro"},[_c('h2',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.more)),_c('span',[_vm._v(_vm._s(item.more2))])])])])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dR/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      text: ['如果生活还没能改变你，那你已经失败了', '我拼尽全力追逐你的脚步，而你却消失在我的眼前', '有些事，只能一个人做，有些关，只能一个人过，有些路，只能一个人走', '没时间是最无力的借口', '我们都希望离别不是句号，而是破折号，指向一个带着笑容的温暖明天', '放下~简单两个字，寥寥十一笔', '有一种落差是，你配不上自己的野心，也辜负了所受的苦难', '喜欢你的我就像个赌徒，输了所有，却还不肯离场', '有勇气，有担当是好事，有能力才是前提', '我不强求，不代表不在乎，没有拥有，所以从未失去', '充满希望的旅途胜过终点的到达', '努力到无能为力，拼搏到感动自己', '时间不会停下来等你，我们现在过的每一天，都是余生中最年轻的一天', '成长是一场温柔的修行，不是越来越强硬和尖锐，而是越来越宽宥和平和', '就怕你一生碌碌无为，还安慰自己平凡可贵', '人生不能太过圆满，求而不得未必是遗憾', '日子就像喝茶一样，只会苦一阵子，不会苦一辈子', '如果不坚强，流泪给谁看', '宁愿跑起来被拌倒无数次，也不要规规矩矩走一辈子', '我们用人生最好的年华做抵押，去担保一个说出来都会被人嘲笑的梦想', '现实是此岸，理想是彼岸，中间隔着湍急的河流，行动则是架在川上的桥梁', '这个世界上没有天才，只有不努力的笨蛋', '心之所向，素履以往，生如逆旅，一苇以航', '你错过的，别人才会得到，正如你得到的都是别人错过的', '何必为昨天的泪，打湿今天的阳光', '人生没有白走的路，每一步都算数', '很多时候，不怕万人阻挡，只怕自己投降', '一个人至少拥有一个梦想，有一个理由去坚强，心若没有栖息的地方，到哪里都是流浪', '看不透是可惜的，看透了是可悲的', '成功不是将来才有的，而是从决定去做的那一刻起，持续累积而成', '你我还会这样相聚吗？我们会不会，像风中转蓬一样，各自滚向渺茫，相忘人生的荒漠', '注定分散的结局何必去挽留，强求的结果都不是好结果', '有些时候，其实自己已经知道答案，再坚持，不过是希望你会给我一个惊喜罢了', '世界上其实根本没有感同身受这回事，针不刺到别人身上，他们就不知道有多痛', '人总是在接近幸福时倍感幸福，在幸福进行时却患得患失', '别以为世界抛弃了你，其实世界压根没空搭理你', '世界上唯一不变的就是变化，世界上唯一可能的就是不可能', '因为有了因为，所以有了所以，既然已成既然，何必再说何必', '当你能飞的时候就不要放弃飞，当你能梦的时候就不要放弃梦', 'Work hard in silence. let success make the noise.(在沉默中努力，让成功自己发声)', 'We are all in the world of anxiety for safe.(我们都在不安的世界里找安稳)', 'Loneliness is a no one to send a bad cold.(孤独是一场无人送药的重感冒)', 'I will start fresh, be some one new.(我要重新开始，做不一样的自己)', 'Never let your fear decide your future.(别让你的恐惧决定了你的未来)', 'I believe good things happen every day.(我相信每天都有好事发生)', 'Never give up, and good luck will find you.(不要放弃，好运总会垂青你的)', 'Win a few, lose a few. that is life.(有得也有失，生活就是如此)'],
      title: '这个世界上没有天才，只有不努力的笨蛋',
      titleUrl: 'https://me.dolyw.com',
      randomIndex: 0,
      i: 0,
      timer: 0,
      str: ''
    };
  },

  computed: {
    /* title: function () {
      return this.text[Math.floor(this.text.length * Math.random())]
    } */
  },
  created: function created() {},
  mounted: function mounted() {
    var t = this;
    /* setInterval(function () {
      // console.log(t.text[Math.floor(t.text.length * Math.random())])
      // console.log(Math.floor(t.text.length * Math.random()))
      // t.title = t.text[Math.floor(t.text.length * Math.random())]
    }, 10000) */
    // 一开始默认给一个随机语句
    /* t.randomIndex = Math.floor(t.text.length * Math.random())
    t.randomText()
    t.typing() */
    t.getHitokoto();
  },

  methods: {
    randomText: function randomText() {
      // 重置索引i和文字
      this.i = 0;
      this.str = this.text[this.randomIndex];
      // 随机数不会和上一次重复，如果获取和上一次相同就重新获取，直到不同为止
      var index = Math.floor(this.text.length * Math.random());
      while (this.randomIndex === index) {
        index = Math.floor(this.text.length * Math.random());
        // console.log(this.randomIndex + ',' + index)
      }
      this.randomIndex = index;
    },
    typing: function typing() {
      var _this = this;

      // 打字
      if (this.i <= this.str.length) {
        if (this.i === this.str.length) {
          this.title = this.str.slice(0, this.i++);
        } else {
          this.title = this.str.slice(0, this.i++) + '_';
        }
        this.timer = setTimeout(function () {
          _this.typing();
        }, 150);
      } else {
        clearTimeout(this.timer);
        // 停顿1.5秒开始删除文字
        setTimeout(function () {
          _this.clearTitle();
        }, 1500);
      }
    },
    clearTitle: function clearTitle() {
      var _this2 = this;

      // 删除文字
      if (this.i >= 0) {
        this.title = this.str.slice(0, this.i--) + '_';
        this.timer = setTimeout(function () {
          _this2.clearTitle();
        }, 50);
      } else {
        clearTimeout(this.timer);
        // 删除完成重置
        this.randomText();
        this.typing();
      }
    },
    getHitokoto: function getHitokoto() {
      var _this3 = this;

      this.axios.get('https://api.fczbl.vip/hitokoto/?encode=json').then(function (response) {
        // console.log(response.data.hitokoto)
        // 重置索引i和文字
        _this3.i = 0;
        _this3.str = response.data.hitokoto;
        _this3.typingNet();
      }).catch(function (error) {
        console.log(error);
        _this3.randomIndex = Math.floor(_this3.text.length * Math.random());
        _this3.randomText();
        _this3.typing();
      });
    },
    typingNet: function typingNet() {
      var _this4 = this;

      // 打字
      if (this.i <= this.str.length) {
        if (this.i === this.str.length) {
          this.title = this.str.slice(0, this.i++);
        } else {
          this.title = this.str.slice(0, this.i++) + '_';
        }
        this.timer = setTimeout(function () {
          _this4.typingNet();
        }, 150);
      } else {
        clearTimeout(this.timer);
        // 停顿1.5秒开始删除文字
        setTimeout(function () {
          _this4.clearTitleNet();
        }, 1500);
      }
    },
    clearTitleNet: function clearTitleNet() {
      var _this5 = this;

      // 删除文字
      if (this.i >= 0) {
        this.title = this.str.slice(0, this.i--) + '_';
        this.timer = setTimeout(function () {
          _this5.clearTitleNet();
        }, 50);
      } else {
        clearTimeout(this.timer);
        // 删除完成重置
        this.getHitokoto();
      }
    }
  }
});

/***/ }),

/***/ "fY6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_danmaku__ = __webpack_require__("rZPc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_danmaku___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_danmaku__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueDanmaku: __WEBPACK_IMPORTED_MODULE_0_vue_danmaku___default.a
  },
  props: {},
  data: function data() {
    return {
      data: ['看什么看，不就是一堆弹幕啊~', "(●'◡'●)", '轻轻点击打开关于页面~∩ω∩', '看到这条弹幕你已经不是前1000了', '暂停听BGM', '大军还有一秒到达现场~⊙﹏⊙', '我猜你肯定盯着看我写的弹幕了', "红红火火恍恍惚惚，韩红会画画后悔画韩寒~(●'◡'●)", '开心的像个200多斤的孩子~⊙０⊙', '前方高能，非战斗人员赶快撤离', '散了吧，要X的~⊙︿⊙', 'B站看片指日可待~∩０∩', '此生无悔入海贼，来世愿做船上人', '我觉得，我可以再抢救一下~●ω●', 'BGM~爱的自杀，再问供养，唉，我都要哭了~∪ω∪', '干了这碗入江陈醋，来世还做傲娇直树~≧ω≦', '卡在了奇怪的地方~＞ω＜', '刘星的蚂蚁花被', '胖儿子沉迷游戏，秃父苦劝无言', '233333', '6666666', '瞬间爆炸', '朱军画质', '牛顿的棺材板压不住了', '教练我想学这个', '实在是不知道说什么~o(*////▽////*)o'],
      list: [{
        id: 'dolyw',
        link: 'https://dolyw.com/go?url=https://me.dolyw.com',
        danmus: []
      }],
      config: {
        channels: 10,
        speed: 7,
        fontSize: 15,
        loop: true
      }
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    // 如果是手机端弹幕显示行数置空，为空表示自动识别容器可容纳最高行数
    if (this.util.isMobile()) {
      this.config.channels = '';
    }
    this.axios.get('https://api.fczbl.vip/hitokoto/?encode=json').then(function (response) {
      // console.log(response.data.hitokoto)
      _this.$refs['danmaku-dolyw'][0].add(response.data.hitokoto);
    }).catch(function (error) {
      console.log(error);
      _this.$refs['danmaku-dolyw'][0].add(_this.data[Math.floor(_this.data.length * Math.random())]);
    });
    this.getHitokoto();
  },

  methods: {
    openLink: function openLink(link) {
      window.open(link);
    },
    getHitokoto: function getHitokoto() {
      var _this2 = this;

      this.axios.get('https://api.fczbl.vip/hitokoto/?encode=json').then(function (response) {
        // console.log(response.data.hitokoto)
        _this2.$refs['danmaku-dolyw'][0].add(response.data.hitokoto);
      }).catch(function (error) {
        console.log(error);
        _this2.$refs['danmaku-dolyw'][0].add(_this2.data[Math.floor(_this2.data.length * Math.random())]);
      }).finally(function () {
        // always executed
        if (_this2.list[0].danmus.length > 2) {
          _this2.$refs['danmaku-dolyw'][0].play();
          setTimeout(function () {
            _this2.$refs['danmaku-dolyw'][0].resize();
          }, 300);
        }
        setTimeout(function () {
          if (_this2.list[0].danmus.length < 30) {
            _this2.getHitokoto();
          }
        }, 500);
      });
    }
  }
});

/***/ }),

/***/ "gZn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://bing.ioliu.cn","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-file-image-o fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Bing壁纸")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://api.i-meto.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-eercast fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("MetoAPI")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=http://pandownload.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-arrow-down fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("PanDown")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=http://www.cyxitong.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-window-maximize fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("SysDown")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://hellodigua.github.io/vue-danmaku","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-rebel fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Danmaku")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=https://squoosh.app","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-play fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Squoosh")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://dolyw.com/go?url=http://www.ofmonkey.com","target":"_blank"}},[_c('div',{staticClass:"cover"},[_c('div',{staticClass:"frontend"},[_c('i',{staticClass:"fa fa-simplybuilt fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("在线工具")])])]),_vm._v(" "),_c('div',{staticClass:"backend"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hWjb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iFcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      text: ['⊙▂⊙', '⊙０⊙', '⊙︿⊙', '⊙ω⊙', '∩０∩', '∩﹏∩', "(●'◡'●)", '●▂●', '●ω●', 'o(∩_∩)o', '∪ω∪', '≧ω≦', '＞ω＜', '∩ω∩', '⊙﹏⊙'],
      title: 'o(∩_∩)o',
      titleUrl: 'https://dolyw.com/go?url=https://me.dolyw.com',
      randomIndex: 0
    };
  },

  computed: {
    /* title: function () {
      return this.text[Math.floor(this.text.length * Math.random())]
    } */
  },
  created: function created() {},
  mounted: function mounted() {
    var t = this;
    /* setInterval(function () {
      // console.log(t.text[Math.floor(t.text.length * Math.random())])
      // console.log(Math.floor(t.text.length * Math.random()))
      // t.title = t.text[Math.floor(t.text.length * Math.random())]
    }, 1500) */
    // 一开始默认给一个随机标题
    t.title = t.text[Math.floor(t.text.length * Math.random())];
    t.changeTitle();
  },

  methods: {
    changeTitle: function changeTitle() {
      var _this = this;

      setTimeout(function () {
        // 随机数不会和上一次重复，如果获取和上一次相同就重新获取，直到不同为止
        var index = Math.floor(_this.text.length * Math.random());
        while (_this.randomIndex === index) {
          index = Math.floor(_this.text.length * Math.random());
          // console.log(this.randomIndex + ',' + index)
        }
        _this.randomIndex = index;
        // 给标题赋值
        _this.title = _this.text[_this.randomIndex];
        _this.changeTitle();
      }, 1500);
    }
  }
});

/***/ }),

/***/ "pSeb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_friend_vue__ = __webpack_require__("q+n/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c98167_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_friend_vue__ = __webpack_require__("cGTZ");
function injectStyle (ssrContext) {
  __webpack_require__("WCuf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79c98167"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_friend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c98167_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_friend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q+n/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_danmaku__ = __webpack_require__("rZPc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_danmaku___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_danmaku__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueDanmaku: __WEBPACK_IMPORTED_MODULE_0_vue_danmaku___default.a
  },
  props: {},
  data: function data() {
    return {
      list: [
      /*
      {
        id: 'flag',
        name: '哞菇',
        more: '头上长着蘑菇',
        more2: '居然是一种牛',
        link: 'http://flag.moe',
        avatar: require('https://dolyw.gitee.io/reader/Image/headt.png'),
        danmus: [
          '咕咕咕！',
          '有女装的潜质',
          '化妆一定很好看',
          '2333',
          '全栈大佬',
          '全栈大佬',
          '全栈大佬'
        ]
      },
      {
        id: 'diygod',
        name: 'DIYgod',
        more: '网红',
        more2: '他家有猫！',
        link: 'https://diygod.me',
        avatar: require('https://dolyw.gitee.io/reader/Image/headt.png'),
        danmus: [
          '哔哩哔哩，干杯( ˊ ▽ ` )丿'
        ],
        config: {
          speed: 2,
          loop: true
        }
      },
      {
        id: 'archeb',
        name: '蚊子',
        more: '我蚊子今天',
        more2: '要把你肛的喵喵叫',
        link: 'https://qwq.moe',
        avatar: require('https://dolyw.gitee.io/reader/Image/headt.png'),
        danmus: [
          '我，蚊子，打钱。'
        ],
        config: {
          fontSize: 30
        }
      },
      {
        id: 'nightcat',
        name: '夜喵',
        more: '有女朋友',
        more2: '最近快住一起了',
        link: 'https://nightcat.win',
        avatar: require('https://dolyw.gitee.io/reader/Image/headt.png'),
        danmus: [
          '？',
          '是个好人',
          '是个萌妹',
          '不是人的',
          '热心萌妹',
          '想被包养，不想上班',
          '我学了你们就再也追不上了',
          '热心群众',
          '大佬的',
          '钱真是好赚，每天坐着玩玩电脑就有收入',
          '喜欢怼人',
          '2333'
        ]
      },
      {
        id: 'geeku',
        name: '树',
        more: '树对我很好',
        more2: '可惜是个男的',
        link: 'https://geeku.net',
        avatar: 'https://dolyw.gitee.io/reader/Image/headt.png',
        danmus: [
          '周树人',
          '百年树人',
          '别树一帜',
          '阿里大树',
          '喵秀于林，树必催之',
          '百科全树'
        ]
      },
      {
        id: 'qingzhen',
        name: '清真',
        more: 'HZFE的群主',
        more2: '博客丑',
        link: 'http://zhaoyuxiang.cn',
        avatar: 'https://dolyw.gitee.io/reader/Image/headt.png',
        danmus: [
          '已经被架空了',
          '便秘',
          '打倒狗群主',
          '没福利差评',
          '不是女装群主，差评',
          '我不拉稀不便秘 怎么就是废物',
          '拉稀（铲铲说的',
          '便秘（铲铲说的'
        ]
      } */

      {
        id: 'dolyw',
        name: '随心',
        more: '第一第一',
        more2: '',
        link: 'https://dolyw.com/go?url=https://dolyw.com',
        avatar: 'https://dolyw.gitee.io/reader/Image/headt2.png',
        danmus: ['第一个当然给自己了', '轻轻双击打开~', '实在是不知道说什么~o(*////▽////*)o']
      }],
      config: {
        // channels为空表示自动识别容器可容纳最高行数
        channels: '',
        fontSize: 14,
        loop: true
      }
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onMouseIn: function onMouseIn(id) {
      var _this = this;

      this.$refs['danmaku-' + id][0].play();
      setTimeout(function () {
        _this.$refs['danmaku-' + id][0].resize();
      }, 300);
    },
    onMouseOut: function onMouseOut(id) {
      this.$refs['danmaku-' + id][0].stop();
    },
    openLink: function openLink(link) {
      window.open(link);
    }
  }
});

/***/ }),

/***/ "wL+9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_home__ = __webpack_require__("26dS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_about__ = __webpack_require__("FBzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_project__ = __webpack_require__("YJHn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_friend__ = __webpack_require__("pSeb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_chain__ = __webpack_require__("QXir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_links__ = __webpack_require__("1WAE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    home: __WEBPACK_IMPORTED_MODULE_0__views_home__["a" /* default */],
    about: __WEBPACK_IMPORTED_MODULE_1__views_about__["a" /* default */],
    project: __WEBPACK_IMPORTED_MODULE_2__views_project__["a" /* default */],
    chain: __WEBPACK_IMPORTED_MODULE_4__views_chain__["a" /* default */],
    friend: __WEBPACK_IMPORTED_MODULE_3__views_friend__["a" /* default */],
    links: __WEBPACK_IMPORTED_MODULE_5__views_links__["a" /* default */]
  },
  data: function data() {
    return {
      flipState: false,
      active: 'home',
      inPage: 'home',
      outPage: '',
      navigation: ['home', 'links', /* 'friend', 'chain', */'about']
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    var colors = [[62, 35, 255], [60, 255, 60], [255, 35, 98], [45, 175, 230], [255, 0, 255], [255, 128, 0]];
    var options = {
      colors: colors,
      step: 0,
      colorIndices: [0, 1, 2, 3],
      gradientSpeed: 0.002
    };
    setInterval(function () {
      _this.updateGradient(options);
    }, 30);
  },

  methods: {
    flip: function flip(status) {
      if (this.active === status) return;
      if (this.active === 'about') {
        this.inPage = '';
        this.outPage = '';
      }
      this.active = status;
      this.flipState = !this.flipState;
      this.flipState ? this.outPage = status : this.inPage = status;
    },
    updateGradient: function updateGradient(option) {
      var obj = document.querySelector('.bg');
      var a = option.colors[option.colorIndices[0]];
      var b = option.colors[option.colorIndices[1]];
      var c = option.colors[option.colorIndices[2]];
      var d = option.colors[option.colorIndices[3]];
      var e = 1 - option.step;
      var f = Math.round(e * a[0] + option.step * b[0]);
      var g = Math.round(e * a[1] + option.step * b[1]);
      var h = Math.round(e * a[2] + option.step * b[2]);
      var i = '#' + (f << 16 | g << 8 | h).toString(16);
      var j = Math.round(e * c[0] + option.step * d[0]);
      var k = Math.round(e * c[1] + option.step * d[1]);
      var l = Math.round(e * c[2] + option.step * d[2]);
      var m = '#' + (j << 16 | k << 8 | l).toString(16);
      option.step = option.step + option.gradientSpeed;
      if (option.step >= 1) {
        option.step %= 1;
        option.colorIndices[0] = option.colorIndices[1];
        option.colorIndices[2] = option.colorIndices[3];
        option.colorIndices[1] = (option.colorIndices[1] + Math.floor(1 + Math.random() * (option.colors.length - 1))) % option.colors.length;
        option.colorIndices[3] = (option.colorIndices[3] + Math.floor(1 + Math.random() * (option.colors.length - 1))) % option.colors.length;
      }
      obj.style.background = '-webkit-gradient(linear, left top, right top, from(' + i + '), to(' + m + '))';
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1b858e998b7146b79717.js